import InterviewDetailNew from "./InterviewDetailNew";
export default InterviewDetailNew;
